var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.cellKindsItems,
      chips: "",
      "small-chips": "",
      "deletable-chips": "",
      multiple: "",
      label: "Cell Kinds:",
    },
    model: {
      value: _vm.modelValue,
      callback: function ($$v) {
        _vm.modelValue = $$v
      },
      expression: "modelValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }